import { deserializeData, MayNull, RandomBattlePassPrize } from '@apeiron/temp'
import { useMutation } from '@apollo/client'
import { randomBattlePassPrizeSchema } from '@src/deserialize/yup/battlePass'
import graphql from '@src/graphql/mutation/randomBattlePassPrize'
import { useState } from 'react'

const useRandomBattlePassPrize = (): Hook => {
  const [query, { loading }] = useMutation(graphql)

  const [data, setData] = useState<Response>(null)

  const fetch = async (input: Request): Promise<Response> => {
    const { keyAssetName } = input

    const response = await query({
      variables: {
        input: {
          keyAssetName
        }
      }
    })

    const prize = deserializeData<Response>(
      response,
      randomBattlePassPrizeSchema
    )

    setData(prize)

    return prize
  }

  return {
    fetch,
    data,
    loading
  }
}

type Request = {
  keyAssetName: string
}

type Response = MayNull<RandomBattlePassPrize>

type Hook = {
  fetch: (input: Request) => Promise<Response>
  data: Response
  loading: boolean
}

export default useRandomBattlePassPrize
